import React, { useState, useEffect } from 'react'
import { API_URL, storedData, secret_key } from '../Constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import axios from 'axios';
import CryptoJS from "crypto-js";
import { Link, useNavigate } from 'react-router-dom';
import loading1 from "../../assets/loading.gif"
import { formatDate } from '../Constants';

function Sendsms() {
  const [searchTerm, setSearchTerm] = useState('');
  const [Sendsms, setSendsms] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  let navigate = useNavigate();

  if (storedData) {
    var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    var logeduserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }

  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = `Bearer ${decryptedToken}`;

  const fetchSendsms = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${API_URL}/get_send_messages/${logeduserData?.company_id}?page=${page}&limit=${50}`,
      headers: { 
        'Authorization': token
      }
    };
    axios
      .request(config)
      .then(function (response) {
        if (response.data.length === 0) {
          setHasMore(false);
        } else {
          setSendsms([...Sendsms, ...response.data]);
          setPage(page + 1);
        }
      })
      .catch(function (error) {
        // handle errors
        if (error?.response?.status === 401) {
          navigate(0);
        }
      });
  };

  useEffect(() => {
    fetchSendsms();
  }, []);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    fetchSendsms();
  };

  const filteredSendsms = Sendsms.filter((Sendsms) => {
    const { message_subject, message_body, created_at } = Sendsms;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
      message_subject.toLowerCase().includes(lowerCaseSearchTerm) ||
      message_body.toLowerCase().includes(lowerCaseSearchTerm) ||
      created_at.toLowerCase().includes(lowerCaseSearchTerm)
    );
  });

  const loadMoreSendsms = () => {
    fetchSendsms(); // Fetch more Sendsms when the user scrolls to the bottom
  };

  return (
    <div style={{ paddingLeft: '10px' }}>
       <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Sent Messages</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active">Sent</li>
                  </ol>
                </div>
              </div>
            </div>
        </div>
      <form className="form-inline justify-content-end searchBar">
        <div className="input-group input-group-sm">
          <input
            className="form-control form-control-navbar"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </form>

<InfiniteScroll
  dataLength={filteredSendsms.length}
  next={loadMoreSendsms}
  hasMore={hasMore}
  loader={
    filteredSendsms.length > 0 ? null : (
      <div className="loadingsubcontainer py-4 text-center">
        <img className="loadingsubimg" src={loading1} alt="Loading..." />
        <p className="mt-2 text-muted">Loading messages...</p>
      </div>
    )
  }
  endMessage={
    <div className="text-center my-3">
      <p className="text-muted">No more SMS to load.</p>
    </div>
  }
>
  <div className="table-responsive shadow-sm rounded">
    <table className="table table-hover table-bordered align-middle mb-0">
      <thead className="table-dark sticky-top">
        <tr>
          <th style={{ width: "5%" }}>S/N</th>
          <th style={{ width: "20%" }}>Subject</th>
          <th style={{ width: "40%" }}>Description</th>
          <th style={{ width: "17.5%" }}>Created At</th>
          <th style={{ width: "17.5%" }}>Last Modified</th>
        </tr>
      </thead>
      <tbody>
        {filteredSendsms.map((Sendsms, index) => (
          <tr key={Sendsms.id} className="table-row">
            <td>{index + 1}</td>
            <td>
              <Link
                to={`/prev_message/${Sendsms.id}?sms_status=${encodeURIComponent(1)}`}
                className="text-primary fw-semibold text-decoration-none"
              >
                {Sendsms.message_subject}
              </Link>
            </td>
            <td style={{ maxWidth: "400px" }} title={Sendsms.message_body}>
              <div
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {Sendsms.message_body}
              </div>
            </td>
            <td>{formatDate(Sendsms.created_at)}</td>
            <td>{formatDate(Sendsms.updated_at)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</InfiniteScroll>

      
    </div>
  )
}

export default Sendsms